import { Animated, Easing, Image, PanResponder, Pressable, useWindowDimensions, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { appColors } from '../../themes/appTheme'
import moment from 'moment'
import ZenText from 'zen-core-elements/src/elements/zenText/zenText'
import { ZenIcon, ZenStatusBar } from 'zen-core-elements'
import { useAppDispatch } from '../../redux/hooks'
import { setDisplaySettings } from '../../redux/slices/commonSlice'
import { useIsFocused } from '@react-navigation/native'

const InActivityScreen = () => {

    const isFocus = useIsFocused()
    const fadeUp = useRef(new Animated.Value(0)).current
    const flickUp = useRef(new Animated.Value(0)).current
    const [fadeDown, setFadeDown] = useState(false)
    const { height } = useWindowDimensions()
    const dispatch = useAppDispatch()
    const formattedTime = (date: Date) => {
        let time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
        return time
    }

    const [getTime, setTime] = useState('')

    useEffect(() => {
        if (isFocus) {
            fadeAnimation()
            flickAnimation()
        }
    }, [])

    useEffect(() => {
        setTime(formattedTime(new Date))
        const timeDebounce = setInterval(() => {
            const date = new Date();
            setTime(formattedTime(date))
        }, 30000)
        return () => clearInterval(timeDebounce)
    }, [])

    const fadeAnimation = () => {
        fadeUp.setValue(0)
        Animated.timing(fadeUp,
            {
                toValue: 1,
                useNativeDriver: true,
                duration: 1000
            }).start()
        if (fadeDown) {
            setFadeDown(false)
            console.log("inside of the if");
            setTimeout(() => {
                dispatch(setDisplaySettings(false))
            }, 1000)
        }
        else {
            console.log("inside of the else");
            setFadeDown(true)
        }
    }

    const moveY = fadeUp.interpolate(
        {
            inputRange: [0, 1],
            outputRange: fadeDown ? [-height / 2, 0] : [0, -height],
        })

    const flickAnimation = () => {
        flickUp.setValue(0)
        Animated.loop(
            Animated.timing(flickUp,
                {
                    toValue: 1,
                    useNativeDriver: true,
                    duration: 2000,
                    easing: Easing.bounce
                }
            ),
            {
                iterations: -1,
            }).start()
    }

    const moveUp = flickUp.interpolate(
        {
            inputRange: [0, 1],
            outputRange: [0, -15]
        })

    const panResponder = PanResponder.create({
        onStartShouldSetPanResponderCapture() {
            fadeAnimation()
            return false
        }
    })

    const arrowOpacity = fadeUp.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 1]
    })

    return (
        <Animated.View {...panResponder.panHandlers} style={{ flex: 1, backgroundColor: appColors.lightBackgroundColor, transform: [{ translateY: moveY }] }}>
            <Pressable></Pressable>
            <ZenStatusBar bgColor={appColors.lightBackgroundColor} />
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', height: '80%', alignItems: 'center' }}>

                <Image source={require('../../assets/pos.png')} style={{ width: '50%', height: '100%' }} resizeMode='contain' />

                <View style={{ justifyContent: 'center', alignItems: 'center', width: '50%' }}>
                    <ZenText content={moment(new Date()).format('dddd DD MMM')} bold style={{ textTransform: 'capitalize', color: appColors.primary }} size={30} />
                    <ZenText content={getTime} bold style={{ textTransform: 'capitalize', color: appColors.primary }} size={80} />
                </View>

            </View>


            <View style={{ justifyContent: 'center', height: '20%', alignItems: 'center', }}>
                <Animated.View style={{ transform: [{ translateY: moveUp }], opacity: arrowOpacity }} >
                    <ZenIcon type={'feather'} name='chevrons-up' size={40} color={appColors.primary} onPress={() => {
                    }
                    } />
                </Animated.View>
                <ZenText content={'press to unlock'} size={'medium'} bold style={{ textTransform: 'capitalize' }} />
            </View>
        </Animated.View>
    )
}

export default InActivityScreen

